/**
 * The ids of the web app's keyboard shortcuts, shared with the server because
 * each one is also a key under the `keyboard.bindings` preference. The web
 * registry (`web/src/components/keyboard/shortcuts.ts`) owns everything else
 * about a shortcut — its default keys, label, and gating — and is typed
 * against this list so the two cannot drift.
 *
 * An id is a stored preference key once a user customizes it, so renaming one
 * silently drops that user's binding.
 */
export const keyboardShortcutIds = [
  "agent.open",
  "nav.calendar",
  "nav.threads",
  "nav.routines",
  "nav.skills",
  "nav.memories",
  "nav.contacts",
  "nav.settings",
  "calendar.viewDay",
  "calendar.viewWeek",
  "calendar.viewMonth",
  "calendar.viewMultiDay",
  "calendar.today",
  "calendar.prev",
  "calendar.next",
  "threads.prev",
  "threads.next",
  "threads.open",
  "threads.back",
  "threads.archive",
  "composer.send",
  "system.help",
  "system.toggleSidebar",
  "system.sync",
  "system.back",
] as const;

export type KeyboardShortcutId = (typeof keyboardShortcutIds)[number];

/** How many key combos one shortcut may carry. */
export const KEYBOARD_BINDING_MAX_COMBOS = 6;

/**
 * Longest single combo accepted. A chord is a few `+`-joined tokens
 * (`mod+shift+bracketleft`); a two-step sequence is two bare tokens joined by
 * a space. Nothing legitimate approaches this.
 */
export const KEYBOARD_COMBO_MAX_LENGTH = 40;
